<template>
  <div class="gen-work">
    <Hero :backImg="require('../../assets/img/lab/work/hero.jpg')" :backImgSp="require('../../assets/img/lab/work/hero_sp.jpg')" alt="" title="クレハの仕事" text="研究・技術職種" />
    <div class="page-contents">
      <WorkDepartment :imagephoto="require('../../assets/img/lab/work/img01.jpg')" :imagephotoSp="require('../../assets/img/lab/work/img01_sp.jpg')" :titlephoto="require('../../assets/img/lab/work/text01.svg')" titlealt="研究開発部門" >
        <WorkCat :textimage="require('../../assets/img/lab/work/text02.svg')" alt="研究開発" catchcopy="新製品の研究開発や既存製品改良のための応用研究および探索的研究" text="スペシャリティ製品の研究開発に取り組み、クレハの将来の発展を支える種を生み出す。新規テーマ・素材の探索のための研究や市場調査、新規開発品の事業化に向けた用途開拓や技術開発のための研究、既存製品の拡販に向けた品質改善のための支援研究、各種分析・構造解析による関係部署の支援などを行う。" />
        <WorkCat :textimage="require('../../assets/img/lab/work/text03.svg')" alt="プロセス開発" catchcopy="製造プロセスの開発や技術課題の解決" text="クレハ製品の工業化に関する技術開発課題の解決に取り組み、生産技術水準の向上を図る。新規開発品の工業化に向けた製造プロセスの開発、新製品に関わる関係各社への技術供与または技術導入・提携のための課題検討、既存製品の品質向上や生産性向上に向けたプロセス課題の検討、製造プラントの海外輸出や生産設備の海外立地に関わるプロセス課題の検討や実行支援などを行う。" />
      </WorkDepartment>

      <WorkDepartment :imagephoto="require('../../assets/img/lab/work/img02.jpg')" :imagephotoSp="require('../../assets/img/lab/work/img02_sp.jpg')" :titlephoto="require('../../assets/img/lab/work/text04.svg')" titlealt="生産・技術部門" >
        <WorkCat :textimage="require('../../assets/img/lab/work/text05.svg')" alt="プラントエンジニアリング" catchcopy="生産設備の設計、建設、メンテナンス" text="クレハ製品の生産設備の設計、建設、メンテナンスに取り組み、グループ全体のエンジニアリング力、生産技術水準の向上を図る。生産設備の新設・増設・更新等に関わる設計から試運転までの計画立案や推進、建設工事の管理、既存プロセス・設備の合理化や効率化に向けた課題検討、生産設備のメンテナンスや管理などを行う。" />
        <WorkCat :textimage="require('../../assets/img/lab/work/text06.svg')" alt="生産技術" catchcopy="製品を安定供給するための管理を担当" text="顧客の要求する品質に合った製品の安定的な製造を支える。生産設備の建設・補修工事の企画・推進、生産設備や運転条件の変更管理、製造工程の改良、製品品質の検査や改良実験に加え、製品苦情・工程トラブルの調査・再発防止、製造現場の安全衛生・保安防災・環境保全の管理などを行う。" />
      </WorkDepartment>

      <WorkDepartment imagephoto="" :titlephoto="require('../../assets/img/lab/work/text07.svg')" titlealt="知的財産部門" >
        <WorkCat :textimage="require('../../assets/img/lab/work/text08.svg')" alt="知的財産権" catchcopy="知的財産権の権利化とその管理" text="知的財産戦略を構築し、事業計画の推進を支援。知的財産権（特許、実用新案、意匠、商標）の出願や権利化、適正な権利行使と有効な権利活用、ライセンス業務の推進、侵害訴訟の対応、他社調査、知的財産権に関する社内教育や啓蒙などを行う。" />
      </WorkDepartment>
    </div>
    <div class="award">
      <div class="award-contents">
        <h4 class="award-title">
          <img src="../../assets/img/lab/work/text09.svg" alt="クレハの代表的な受賞歴">
        </h4>
        <ul class="award-list">
          <li>第11回日本化学会化学技術賞 「ポリ塩化ビニリデン系合成樹脂の製造とその加工技術の確立」</li>
          <li>第20回日本化学会化学技術賞 「ピッチを原料とする炭素繊維の研究と工業化」（群馬大学と共同受賞）</li>
          <li>第28回日化協技術賞 「農業用殺菌剤メトコナゾールの開発とその企業化」</li>
          <li>第11回2002年度分離技術会技術賞 呉羽連続結晶精製装置</li>
          <li>2011Edison New Product Awards新製品賞 PGA樹脂「クレダックス（Kuredux）」</li>
          <li>第5回ものづくり日本大賞経済産業大臣賞 「環境負荷低減を実現する高機能型生分解性樹脂ポリグリコール酸（PGA)の開発」</li>
          <li>第65回日本化学会化学技術賞 「ポリグリコール酸の工業的製造技術の確立と機能性・環境適性に優れた材料としての新市場開拓」</li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import Hero from '@/components/Hero.vue';
import WorkDepartment from '@/components/lab/WorkDepartment.vue';
import WorkCat from '@/components/lab/WorkCat.vue';
export default {
  name: 'GenWork',
  components: {
    Hero,
    WorkDepartment,
    WorkCat
  },
}
</script>

<style lang="scss" scoped>
.gen-work {
  background-color: #282828;
  background-image: linear-gradient(#333 1px, transparent 0),
                    linear-gradient(90deg, #333 1px, transparent 0);
  background-size: 10px 10px;
}
.page-contents {
  max-width: 1000px;
  width: 90%;
  margin: 0 auto;
  padding: 50px 0 100px 0;
}
.award {
  padding: 50px 0;
  background-image: radial-gradient(circle at 40% 120%, #3fae00 -20%, transparent 40% ),radial-gradient(circle at 70% 130%, #3fae00 -20%, transparent 40% ),radial-gradient(circle at top right, #3fae00 -40%, transparent 40% );
  background-size: 100%;
  background-color: #00797f;
}
.award-contents {
  max-width: 1000px;
  width: 90%;
  margin: 0 auto;
}
.award-title {
  img {
    height: 56px;
    @media print,screen and (max-width: 767px) {
      height: 30px;
    }
  }
}
.award-list {
  border-top: 1px solid #fff;
  color: #fff;
  li {
    border-bottom: 1px solid #fff;
    padding: 0.5em 0;
  }
}
</style>
